module.exports = __webpack_public_path__ + "static/media/  (160).4057345f.jpg";